import React, { useState, useContext } from "react";
import ReactModal from "react-modal";
import * as yup from "yup";
import { Field, Formik } from "formik";
import Button from "../Button";
import Title from "../Title";
import modalStyle from "./modal.module.sass";
import { CustomInputComponent } from "../Eshop/CustomInput";
import { Checkbox } from "../ContactForm/CustomInput";
import ContactFormMutation from "../ContactForm/ContactFormMutation";
import { CM_MAX_ITEM_ORDER_QUANTITY, URLS } from "../../constants";

import { checkoutContext } from "../../context/checkoutContextProvider";

ReactModal.setAppElement("body");
ReactModal.defaultStyles.overlay.backgroundColor = "rgba(77, 100, 110, 0.95)";
ReactModal.defaultStyles.overlay.zIndex = 10000;

const coinContactSchema = () =>
    yup.object().shape({
        email: yup
            .string()
            .email("Špatný formát e-mailu")
            .required("Vyplňte e-mail"),
        gdprContact: yup.bool().oneOf([true], "Musíte souhlasit s podmínkami"),
    });

const Modal = props => {
    const { adviser } = useContext(checkoutContext);

    const initialState = {
        adviser,
        email: "",
        gdprContact: false,
    };

    const [isSubmitted, setIsSubmitted] = useState(false);
    return (
        <ReactModal className={modalStyle.simpleModalReact} {...props}>
            {props.type === "contact" && (
                <button
                    className={modalStyle.modalClose}
                    onClick={props.onRequestClose}
                >
                    ✕
                </button>
            )}
            {props.type === "contact" ? (
                <div className={modalStyle.simpleModalContent}>
                    <Title>
                        {isSubmitted ? "Děkujeme" : "Zanechte nám váš kontakt"}
                    </Title>
                    <div className={modalStyle.modalMain}>
                        <p>
                            Ozveme se vám, pokud bude{" "}
                            <strong>{props.coinName}</strong> opět k dispozici.
                        </p>
                        <p>
                            Nezoufejte, když se na vás nedostane. Připravujeme
                            další limitované edice, o kterých vás budeme
                            informovat.
                        </p>
                    </div>
                    {!isSubmitted && (
                        <Formik
                            initialValues={initialState}
                            onSubmit={async (values, { setSubmitting }) => {
                                setSubmitting(true);

                                values.coinName = props.coinName;
                                values.gdpr = values.gdprContact;
                                values.type = "coin";

                                await ContactFormMutation(values);

                                setSubmitting(false);
                                setIsSubmitted(true);
                            }}
                            validationSchema={coinContactSchema()}
                            render={props => (
                                <form
                                    onSubmit={props.handleSubmit}
                                    className={modalStyle.modalInputContainer}
                                >
                                    <Field
                                        name="email"
                                        component={CustomInputComponent}
                                        label="E-mail *"
                                        horizontal="horizontal"
                                        placeholder="@"
                                    />

                                    <Field
                                        component={Checkbox}
                                        name="gdprContact"
                                        id="gdprContact"
                                    >
                                        <label htmlFor="gdprContact">
                                            Potvrzuji, že jsem se seznámil/a se{" "}
                                            <a
                                                target={"_blank"}
                                                rel="noopener noreferrer"
                                                href={URLS.gdpr}
                                            >
                                                zpracováním mých osobních údajů
                                            </a>{" "}
                                            ze strany společnosti KAPITOL, a.s.
                                        </label>
                                    </Field>
                                    <Button
                                        type={"submit"}
                                        width={"full"}
                                        mt={10}
                                        disabled={props.isSubmitting}
                                    >
                                        {props.isSubmitting
                                            ? "Ukládám…"
                                            : "Dejte mi vědět"}
                                    </Button>
                                </form>
                            )}
                        />
                    )}
                </div>
            ) : (
                <div className={modalStyle.simpleModalContentCart}>
                    <Title>
                        Gratulujeme,
                        <br />
                        produkt byl přidán do&nbsp;košíku.
                    </Title>
                    <div className={modalStyle.modalMain}>
                        <p>
                            Nyní můžete pokračovat v&nbsp;nákupu a&nbsp;vybrat
                            si&nbsp;další produkty z&nbsp;naší nabídky nebo
                            přejít do&nbsp;košíku, kde dokončíte svou
                            objednávku.
                        </p>
                    </div>
                    <footer>
                        <Title type="h3" mb="28">
                            Investice do&nbsp;zlata - s&nbsp;námi vždy bezpečně
                            a&nbsp;výhodně
                        </Title>
                        <div className={modalStyle.buttons}>
                            <Button
                                onClick={props.onRequestClose}
                                color="outline-gold-dark"
                            >
                                Pokračovat v&nbsp;nákupu
                            </Button>
                            <Button type="link" uri="/e-shop/cart/">
                                Přejít do&nbsp;košíku
                            </Button>
                        </div>
                    </footer>
                    {props.overOrderLimit && (
                        <p className={modalStyle.alert}>
                            Lze objednat maximálně {CM_MAX_ITEM_ORDER_QUANTITY}{" "}
                            kusů od jednoho produktu. Do košíku jsme přidali jen
                            položky do celkového množství 5 kusů na produkt.
                        </p>
                    )}
                </div>
            )}
        </ReactModal>
    );
};

export default Modal;
